var _desc, _rect, _rect2, _path, _path2, _path3, _path4, _text, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQacoderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 64,
    viewBox: "0 0 248 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "QA Coder logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "QA Coder wordmark with a QA check symbol.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 244,
    height: 60,
    rx: 17,
    fill: "url(#bg)",
    stroke: "url(#border)",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 42,
    height: 40,
    rx: 12,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 41.5C29.9 41.5 24.5 36.28 24.5 29.85C24.5 23.42 29.9 18.2 36.5 18.2C43.1 18.2 48.5 23.42 48.5 29.85C48.5 32.12 47.82 34.24 46.65 36.03L50.2 39.42L46.8 42.72L43.38 39.45C41.42 40.75 39.05 41.5 36.5 41.5ZM36.5 36.85C40.42 36.85 43.6 33.72 43.6 29.85C43.6 25.98 40.42 22.85 36.5 22.85C32.58 22.85 29.4 25.98 29.4 29.85C29.4 33.72 32.58 36.85 36.5 36.85Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8 30.4L35.42 32.95L41.05 26.25",
    stroke: "#0F766E",
    strokeWidth: 3.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76 17H108",
    stroke: "#38BDF8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115 17H139",
    stroke: "#34D399",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 43.5,
    fill: "#FFFFFF",
    fontFamily: "Poppins, Montserrat, Segoe UI, Arial, sans-serif",
    fontSize: 27,
    fontWeight: 900,
    letterSpacing: -1.3
  }, "QA Coder")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 2,
    y1: 2,
    x2: 246,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F172A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#184E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F766E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "border",
    x1: 0,
    y1: 0,
    x2: 248,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93C5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EEAD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQacoderLogo);
export default __webpack_public_path__ + "static/media/qacoder-logo.79ce89c768deb72c964d1cfc580e6648.svg";
export { ForwardRef as ReactComponent };